import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';

import { Component, Injector } from '@angular/core';

import { ComponentInterface } from './component.interface';

import { PoI18nService, PoLanguage } from '@po-ui/ng-components';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';

/**
 * @description
 *
 * Componente básico
 */

@Component({
    template: '',
    standalone: false
})

export abstract class ComponentBase implements ComponentInterface {



	/**
		* Labels traduzidos
		*/
	public literalsCp: any = {};


	/**
	 * LocaleId para os filtros de data, currency e decimal
	 *
	 * @type {string}
	 * @memberof ComponentBase
	 */
	public localeId: string;

	/**
	 * Exibe ou não a animação de espera de consulta
	 */
	private _loading: boolean;

	public get loading(): boolean {
		return this._loading;
	}

	private _loadingCount: number = 0;

	/**
	 * Serviço HTTP
	 */
	public http: HttpClient;

	/**
	 * Serviço de Rotas
	 */
	public router: Router;

	/**
	 * Serviço da Rota Ativa
	 */
	public activatedRoute: ActivatedRoute;

	/**
	 * Serviço de Tradução
	 */
	public poI18nService: PoI18nService;

	/**
	 * LIngua selecionada
	 */
	public languageCh: PoLanguage | undefined;


	/** Linguas suportadas */
	public supportedLanguages: Array<string> = ['pt', 'en', 'es'];

	constructor(
		public injector: Injector
	) {
		this.http = injector.get(HttpClient);
		this.router = injector.get(Router);
		this.activatedRoute = injector.get(ActivatedRoute);
		this.poI18nService = injector.get(PoI18nService);
	}

	/**
	 * Exibe a animação de espera
	 */
	showLoading() {
		if (this._loadingCount === 0) {
			this._loading = true;
		}
		this._loadingCount++;
	}

	/**
	 * Esconde a animação de espera
	 */
	hideLoading() {
		if (this._loadingCount > 0) {
			this._loadingCount--;
		}

		if (this._loadingCount === 0) {
			this._loading = false;
		}
	}

	ngOnInit(): void { 
		// Inicialização
	}

	protected changeLanguageBase(contextApp: ContextApplication): void {
		this.poI18nService
			.getLiterals({ language: this.getLanguage(contextApp) })
			.subscribe(objLiterals => {
				this.literalsCp = objLiterals;
				this.onReceiveLiterals();
			});
	}

	protected getLanguage(contextApp: ContextApplication): string {
		let language = navigator.language;

		if (contextApp && contextApp.language) {
			language = contextApp.language;
		}

		if (language.includes('-')) {
			language = language.split('-')[0];
		}

		if (this.supportedLanguages.includes(language)) {
			this.poI18nService.setLanguage(language);
			return language;
		}
		else {
			return this.poI18nService.getLanguage();
		}
	}

	abstract onReceiveLiterals(): void;

	ngOnDestroy(): void {
		// Destroy
	}
}
